import React from "react";
import { Link, useLocation } from "react-router-dom";
import { LayoutDashboard, Users, CheckSquare, Sparkles, Menu } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger, SheetTitle } from "./ui/sheet";

const NAV_ITEMS = [
  { path: "/dashboard", label: "Home", icon: LayoutDashboard },
  { path: "/leads", label: "Leads", icon: Users },
  { path: "/tasks", label: "Tasks", icon: CheckSquare },
  { path: "/copilot", label: "AI", icon: Sparkles },
];

const MobileBottomNav = ({ onMoreClick, moreOpen, onMoreClose, navItems, navGroups }) => {
  const location = useLocation();

  return (
    <>
      {/* Bottom Nav Bar */}
      <nav
        className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md border-t border-slate-200 safe-area-bottom"
        data-testid="mobile-bottom-nav"
      >
        <div className="flex items-center justify-around h-14 px-1">
          {NAV_ITEMS.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;
            return (
              <Link
                key={item.path}
                to={item.path}
                data-testid={`bottom-nav-${item.label.toLowerCase()}`}
                className={`flex flex-col items-center justify-center flex-1 py-1 transition-colors ${
                  isActive ? "text-amber-600" : "text-slate-400"
                }`}
              >
                <Icon className="w-5 h-5" />
                <span className="text-[10px] mt-0.5 font-medium">{item.label}</span>
              </Link>
            );
          })}
          {/* More button */}
          <Sheet open={moreOpen} onOpenChange={(open) => open ? onMoreClick() : onMoreClose()}>
            <SheetTrigger asChild>
              <button
                data-testid="bottom-nav-more"
                className="flex flex-col items-center justify-center flex-1 py-1 text-slate-400"
              >
                <Menu className="w-5 h-5" />
                <span className="text-[10px] mt-0.5 font-medium">More</span>
              </button>
            </SheetTrigger>
            <SheetContent side="bottom" className="rounded-t-2xl max-h-[70vh] overflow-y-auto pb-8">
              <SheetTitle className="sr-only">Navigation Menu</SheetTitle>
              <div className="pt-2 pb-4">
                <div className="w-10 h-1 bg-slate-200 rounded-full mx-auto mb-4" />
                {navGroups ? navGroups.map((group) => {
                  const filtered = group.items.filter(n => !NAV_ITEMS.some(bn => bn.path === n.path));
                  if (filtered.length === 0) return null;
                  return (
                    <div key={group.label} className="mb-3">
                      <p className="text-[11px] font-semibold text-slate-400 uppercase tracking-wider px-4 mb-1.5">{group.label}</p>
                      <div className="grid grid-cols-3 gap-1 px-2">
                        {filtered.map((item) => {
                          const Icon = item.icon;
                          const isActive = location.pathname === item.path;
                          return (
                            <Link
                              key={item.path}
                              to={item.path}
                              onClick={onMoreClose}
                              className={`flex flex-col items-center gap-1.5 py-3 px-2 rounded-xl transition-colors ${
                                isActive
                                  ? "bg-amber-50 text-amber-700"
                                  : "text-slate-600 hover:bg-slate-50"
                              }`}
                            >
                              <Icon className="w-5 h-5" />
                              <span className="text-[11px] font-medium text-center leading-tight">{item.label}</span>
                            </Link>
                          );
                        })}
                      </div>
                    </div>
                  );
                }) : (
                  <div className="grid grid-cols-3 gap-1 px-2">
                    {navItems
                      .filter((n) => !NAV_ITEMS.some((bn) => bn.path === n.path))
                      .map((item) => {
                        const Icon = item.icon;
                        const isActive = location.pathname === item.path;
                        return (
                          <Link
                            key={item.path}
                            to={item.path}
                            onClick={onMoreClose}
                            className={`flex flex-col items-center gap-1.5 py-3 px-2 rounded-xl transition-colors ${
                              isActive
                                ? "bg-amber-50 text-amber-700"
                                : "text-slate-600 hover:bg-slate-50"
                            }`}
                          >
                            <Icon className="w-5 h-5" />
                            <span className="text-[11px] font-medium text-center leading-tight">{item.label}</span>
                          </Link>
                        );
                      })}
                  </div>
                )}
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </nav>

      {/* Spacer so content isn't hidden behind bottom nav */}
      <div className="md:hidden h-14" />
    </>
  );
};

export default MobileBottomNav;
